import { bowtieTranslations } from 'app/area/bowtie/constants';
import { BowtieFiltersFavourite } from 'app/area/bowtie/filters/bowtie-filters-favourite';
import { useActionCreators } from 'app/area/bowtie/filters/hooks';
import { selectBowtieFavouriteId } from 'app/area/bowtie/selectors';
import { FavouriteInstance } from 'app/area/favourite/favourite-context';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { STATE } from 'app/constants';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import styles from './bowtie-filters.scss';

interface BowtieFiltersProps {
  onClose: () => void;
}

export function BowtieFilters({
  onClose
}: BowtieFiltersProps) {

  const translations = useTranslation(STATE.bowtie, bowtieTranslations);

  const bowtieFavouriteId = useSelector(selectBowtieFavouriteId);

  const {
    incrementRequestId
  } = useActionCreators();

  const onDone = useCallback(() => {
    incrementRequestId?.();
    onClose?.();
  }, [onClose, incrementRequestId]);

  return (
    <FavouriteInstance>
      <ModalWrapper 
        onClose={onDone} 
        onDone={onDone} 
        closeOnDone 
        headerTitle={translations.filters_header} 
        btnTitle={translations.done}
      >
        <div className={styles.infoText}>{translations.filters_help_text}</div>
        <BowtieFiltersFavourite favouriteId={bowtieFavouriteId} />
      </ModalWrapper>
    </FavouriteInstance>
  );
}
